// extracted by mini-css-extract-plugin
export var awardListWrapper = "index-module--awardListWrapper--9ZeL-";
export var button = "index-module--button--Nh-bJ";
export var content = "index-module--content--BSt8j";
export var des = "index-module--des--HxcpA";
export var img = "index-module--img---eObD";
export var itemTitle = "index-module--itemTitle--3Ic5h";
export var itemWrapper = "index-module--itemWrapper--MZMd1";
export var list = "index-module--list--7FcYL";
export var title = "index-module--title--RKHkA";